<template>
	<o-select
		v-bind="$attrs"
		v-model="setup.userId"
		class="shared-select-assignee"
		:label="$t('common.shared.forms.assignTo')"
		:options="options"
		track-key="id"
		value-key="id"
		display-key="name">
		<template #value="{ item }">
			<span
				v-if="item"
				class="shared-select-assignee__selected">
				<o-avatar
					size="xs"
					:name="item.name"
					:avatar="item.avatarId"
					root-url="/app/avatar/"/>
				{{ item.name }}
			</span>
		</template>

		<template #option="{ item }">
			<div class="shared-select-assignee__item">
				<o-avatar
					class="shared-select-assignee__avatar"
					size="xs"
					:name="item.name"
					:avatar="item.avatarId"
					root-url="/app/avatar/"/>
				<div class="shared-select-assignee__text">
					<div class="shared-select-assignee__name">
						{{ item.name }}
						<o-label
							v-if="item.id === setup.self.id"
							size="sm">
							{{ $t('common.label.me') }}
						</o-label>
					</div>
					<small class="shared-select-assignee__mail">{{ item.authLogin }}</small>
				</div>
			</div>
		</template>
	</o-select>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedSelectAssigneeEmits, SharedSelectAssigneeProps } from './SharedSelectAssigneeSetup';
import SharedSelectAssigneeSetup from './SharedSelectAssigneeSetup';
const emits = defineEmits<SharedSelectAssigneeEmits>() as SharedSelectAssigneeEmits;
const props = withDefaults(defineProps<SharedSelectAssigneeProps>(), SharedSelectAssigneeSetup.defaultProps);
const setup = new SharedSelectAssigneeSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
@import "@/styles/mixins.less";

.shared-select-assignee {
	&__item {
		display: flex;
		gap: 0.625rem;
		align-items: center;
		width: 100%;
		padding: 0.25rem 0;
	}

	&__text {
		flex: 1;
	}

	&__name {
		display: flex;
		gap: 1rem;
		align-items: center;
		justify-content: space-between;
		font-weight: 600;
		color: var(--grey-darker);

		.selected & {
			color: white;
		}
	}

	&__mail {
		color: var(--grey-dark);

		.selected & {
			color: white;
		}
	}

	&__selected {
		display: flex;
		gap: 0.625rem;

		:deep(.orion-avatar) {
			.circle(1.25rem);
		}
	}
}
</style>
